
import { EnergyRatingItem } from "@/types";
import { computed, defineComponent } from "vue";
import EnergyRatingIndicator from "./EnergyRatingIndicator.vue";
import { GBRatings, ROIRatings } from "@/constants";
export default defineComponent({
  props: {
    current: {
      type: Number,
      required: false,
    },
    potential: {
      type: Number,
      required: false,
    },
    coverage: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      default: "roi",
    },
  },
  components: { EnergyRatingIndicator },
  setup(props) {
    const ratings = computed<EnergyRatingItem[]>(() =>
      props.country.toLowerCase() === "roi" ? ROIRatings : GBRatings
    );

    const currentEnergyRating = computed(() =>
      getEnergyRatingItem(props.current)
    );
    const potentialEnergyRating = computed(() =>
      getEnergyRatingItem(props.potential)
    );

    function getEnergyRatingItem(val?: number): EnergyRatingItem | undefined {
      if (typeof val === "undefined") {
        return;
      }

      return (
        [...ratings.value]
          .reverse()
          .slice(1)
          .find((x) => isInRange(x, val)) ||
        ratings.value[ratings.value.length - 1]
      );
    }

    function isInRange(rating: EnergyRatingItem, val: number): boolean {
      return val >= rating.min && (rating.max ? val <= rating.max : true);
    }

    return { ratings, currentEnergyRating, potentialEnergyRating, isInRange };
  },
});
